import React from 'react';

const BaseLabel = ({ data }) => {
    const icon = data.icon ? (
        <img style={{ verticalAlign: 'text-bottom' }} src={data.icon} />
    ) : null;

    return (
        <div
            id="boot"
            style={{
                background: 'transparent',
                marginTop: 6,
                cursor: 'initial !important'
            }}
        >
            {icon}{' '}
            <span
                style={{
                    padding: '2px 4px 2px 4px'
                }}
            >
                {data.name}
            </span>
        </div>
    );
};

export default BaseLabel;
